module.exports = __webpack_public_path__ + "img/how-it-works-1.c3d3c8b8.svg";